// NO 3RD PARTY SOFTWARE IN THIS PACK
// It is intended to be used for "safe iframes" which may contain sensitive form elements.

import "~/forms/ujs";
import "~/forms/validate";
import { assignCopyButtons } from "~/utils/copy";
import { initStripeForm } from "~/forms/stripe";

import axios from "axios";

// Observes changes to iframe height and emits to parent
function sendHeightMessage() {
  window.top.postMessage(
    `setHeight,${document.body.offsetHeight}`,
    window.PERMITTED_HOST
  );
}
function monitorHeight() {
  document.getElementById("document-height-listener").contentWindow.onresize =
    sendHeightMessage;
}

window.axios = axios;
window.initStripeForm = initStripeForm;
window.addEventListener("DOMContentLoaded", sendHeightMessage);
window.addEventListener("DOMContentLoaded", monitorHeight);
window.addEventListener("DOMContentLoaded", assignCopyButtons);
